export default () => ({
  countryResidence: null,
});
